<template>
    <div class="invoice-info">

        <div class="client-info">
            <p v-if="sellerNameIs">{{ sellerName }}</p>
            <p v-if="addressIs">{{address}}</p>
            <p v-for="item in propsRightCustom" :key="item.value">{{item.name}} {{item.value}}</p>
        </div>

        <div class="date">
            <h2 class="small" v-if="clientNameIs"> {{clientName}} </h2>
            <h2 class="small" v-for="item in propsLeftCustom" :key="item.value">{{item.name}} {{item.value}}</h2>

            <p class="invoice-num" v-if="invoiceNumIs">INVOICE # <span>{{ invoiceNum }}</span></p>
            <h2 v-if="dateIs" class="small"><span> {{ date }}</span></h2>

        </div>

    </div>
</template>

<script>
    export default ({
        data: () => ({

            "date": "",

        }), methods: {
            setDate() {
                var today = new Date();
                var now = (today.toString()).split(" ")
                return now[2] + " " + now[1] + " " + now[8] + " " + now[3]
            }
        },

        props: {

            clientName: {},
            dateCustom: {},
            invoiceNum: {},
            sellerName: {},
            clientNameIs: Boolean,
            dateIs: Boolean,
            invoiceNumIs: Boolean,
            sellerNameIs: Boolean,
            address: {},
            addressIs: Boolean,
            propsLeftCustom: {},
            propsRightCustom: {}


        },
        beforeMount() {
            if (this.dateCustom == undefined || this.dateCustom == "" || this.dateCustom == "default")
                this.date = this.setDate()
            else this.date = this.dateCustom
        },
    })
</script>

<style scoped>
    .invoice-info {
        letter-spacing: 1px;
        margin: 0px 0 20px 0;
        background-color: rgb(230, 225, 225);
        justify-content: space-between;
        align-items: center;
        padding: 0 50px;

    }

    .invoice-info .date h2 {
        font-size: 13px;
        color: #222;
        margin-bottom: 5px;
    }

    .invoice-num{
        font-size: 13px;
        word-spacing: 2px;
        letter-spacing: 3px;
        font-weight: bold;
        margin-top: 12px;
    }

    .invoice-info .date .small {
        font-size: 11px;
        color: #333;
        margin-bottom: 3px;
    }

    .invoice-info .date p span {
        color: #111;
    }

    .invoice-info .client-info p {
        color: #333;
        font-size: 11px;
        text-align: right;
        word-spacing: 2px;
    }

</style>